import createAPI from './hotel-api';

const credentialsConf = {
  withCredentials: true,
  validateStatus: () => true,
};

const api = createAPI(process.env.MUJI_APP_HOST, {
  showNotification: true,
});

export function login({ username, password }) {
  return api.postJson('/portal/api/v2/user/login', { username, password }, credentialsConf);
}

export function logout() {
  return api.postJson('/portal/api/v2/user/logout', {}, credentialsConf);
}

export function userInfo(needLogin) {
  return api.getJson('/portal/api/v2/user/info', {}, credentialsConf);
}

export function resetPasswd(password, newPassword) {
  return api.putJson('/portal/api/v2/user/reset_passwd', { password, newPassword }, credentialsConf);
};
